export const relitixProductionFilterTooltip = `
<li><strong>Total $ Production LTM</strong>
  <ul>
    <li>Sales production volume over the last twelve months.</li>
  </ul>
</li>
<li><strong>Total # Production LTM</strong>
  <ul>
    <li>Total units sold by an agent on either side of a transaction in the last twelve months.</li>
  </ul>
</li>
<li><strong>$ Change</strong>
  <ul>
    <li>Sales volume production in the last twelve months compared to the prior twelve months on a dollar basis.</li>
  </ul>
</li>
<li><strong>% Change</strong>
  <ul>
    <li>Sales volume production in the last twelve months compared to the prior twelve months on a percentage basis.</li>
  </ul>
</li>
<li><strong>Average Sales Price</strong>
  <ul>
    <li>The average sales price of all transactions sold by the agent in the last twelve months.</li>
  </ul>
</li>
`;

export const RELITIX_FIELD_TOOLTIPS = {
  closestOffice:
    "The company office that best matches where the agent closes business geographically. Use it to identify the office they are most likely to fit with for recruiting.",
  closestOfficeAddress:
    "Address for the matched company office. Use it with the distance fields to understand whether the agent's production area is practical for that office.",
  distanceToClosestOffice:
    "Distance from the geographic center of the agent's production to your matched office. Use it to judge how close their business is to your recruiting office.",
  distanceToCurrentOffice:
    "Distance from the geographic center of the agent's production to their current office. Larger distances may suggest a virtual office, weak office tie, or a better geographic fit elsewhere.",
  centerOfProductionZip:
    "ZIP code containing the geographic center of the agent's historical production. Use it to understand where their business is centered, even if their transactions span multiple areas.",
  teamLeader:
    "Team leader data appears when the MLS sends it. Treat it as directional, not complete; some MLSs may list team leaders as their own team leader or omit team relationships.",
  firstTransactionCurrentOffice:
    "Date of the agent's first MLS transaction at their current office. Use it to understand tenure with the current brokerage and how established that office relationship may be.",
  firstTransactionMls:
    "Date of the agent's first transaction recorded in the MLS. Use it to tell whether the agent is newer or more experienced, keeping in mind MLS history may be limited.",
  rookieRating:
    "Predicts the likelihood that an agent with less than 36 months in the MLS will still be active in year four and closing at least $3M annually. Use it to compare rookies against peers and find promising agents early.",
  currentSwitchRisk:
    "Shows how closely the agent's MLS activity matches patterns from agents who later switched brokerages. Use yellow/red as a timing signal after you narrow your list, not as a guarantee the agent will move.",
  listingEffectivenessGrade:
    "Grades how effectively the agent handles listings based on recent MLS performance, including factors like time on market, pricing accuracy, and sales success. Use it to identify strong listing agents or coaching opportunities.",
  listingEffectivenessImpact:
    "Estimated dollar impact of the agent's listing effectiveness compared with what an average agent would have produced on similar listings. Negative impact can signal coaching needs; strong positive impact supports a performance-focused recruiting message.",
  fiveYearBattingAverage:
    "Percentage of the agent's listings from the last five years, excluding the most recent six months, that closed. Compare it with Listing Effectiveness Grade to spot agents trending up, trending down, or needing listing support.",
  fiveYearListingCount:
    "Number of listings behind the five-year batting average, excluding the most recent six months. Use it as context: a batting average based on more listings is a stronger signal than one based on only a few.",
  lastUpdated:
    "Date the Relitix data was last refreshed in BrokerKit. Use it to confirm how current the metrics are before relying on them for outreach.",
};

const tooltipListItem = (label, tooltip) => `
<li><strong>${label}</strong>
  <ul>
    <li>${tooltip}</li>
  </ul>
</li>
`;

const relitixSubscriptionPreamble = (linkColor) => `
<li>
  These parameters require a Relitix subscription
  (details <a class="${linkColor}" href="https://support.brokerkit.app/hc/help/articles/how-to-configure-the-relitix-integration-in-brokerkit" target="_blank" rel="noopener noreferrer">here</a>).
</li>
`;

export const relitixProductionInsightsFilterTooltip = (
  linkColor = "text-green",
) => `
${relitixSubscriptionPreamble(linkColor)}
${tooltipListItem("Rookie Rating", RELITIX_FIELD_TOOLTIPS.rookieRating)}
${tooltipListItem("Current Switch Risk", RELITIX_FIELD_TOOLTIPS.currentSwitchRisk)}
${tooltipListItem("Listing Effectiveness Grade", RELITIX_FIELD_TOOLTIPS.listingEffectivenessGrade)}
${tooltipListItem("Listing Effectiveness Impact", RELITIX_FIELD_TOOLTIPS.listingEffectivenessImpact)}
${tooltipListItem("Five Year Batting Average", RELITIX_FIELD_TOOLTIPS.fiveYearBattingAverage)}
${tooltipListItem("Five Year Listing Count", RELITIX_FIELD_TOOLTIPS.fiveYearListingCount)}
`;

export const relitixProductionLocationFilterTooltip = (
  linkColor = "text-green",
) => `
${relitixSubscriptionPreamble(linkColor)}
${tooltipListItem("Closest Office Name", RELITIX_FIELD_TOOLTIPS.closestOffice)}
${tooltipListItem("Closest Office Address", RELITIX_FIELD_TOOLTIPS.closestOfficeAddress)}
${tooltipListItem("Distance to Closest Office", RELITIX_FIELD_TOOLTIPS.distanceToClosestOffice)}
${tooltipListItem("Distance to Current Office", RELITIX_FIELD_TOOLTIPS.distanceToCurrentOffice)}
${tooltipListItem("Office Postal Code", "Agent's office mailing ZIP code. Use it as office-location context when comparing office and production geography.")}
${tooltipListItem("Center of Production Postal Code", RELITIX_FIELD_TOOLTIPS.centerOfProductionZip)}
`;

export const relitixProductionDatesFilterTooltip = (
  linkColor = "text-green",
) => `
${relitixSubscriptionPreamble(linkColor)}
${tooltipListItem("First Transaction at Current Office", RELITIX_FIELD_TOOLTIPS.firstTransactionCurrentOffice)}
${tooltipListItem("First Transaction at MLS", RELITIX_FIELD_TOOLTIPS.firstTransactionMls)}
`;
